import { useState, useEffect } from "react";
import { useData } from "@/context/DataContext";

function diff(target) {
  const t = new Date(target).getTime() - Date.now();
  if (isNaN(t) || t <= 0) return { d: 0, h: 0, m: 0, s: 0, done: t <= 0 };
  return {
    d: Math.floor(t / 86400000),
    h: Math.floor((t / 3600000) % 24),
    m: Math.floor((t / 60000) % 60),
    s: Math.floor((t / 1000) % 60),
    done: false,
  };
}

export const Countdown = ({ compact }) => {
  const { settings } = useData();
  const target = settings?.countdown_target || "2026-11-07T09:00:00";
  const [t, setT] = useState(diff(target));

  useEffect(() => {
    const i = setInterval(() => setT(diff(target)), 1000);
    return () => clearInterval(i);
  }, [target]);

  const units = [
    { v: t.d, l: "Dagar" },
    { v: t.h, l: "Timmar" },
    { v: t.m, l: "Minuter" },
    { v: t.s, l: "Sekunder" },
  ];

  return (
    <div data-testid="countdown" className={`grid grid-cols-4 gap-2 sm:gap-4 ${compact ? "max-w-md" : "max-w-xl"}`}>
      {units.map((u) => (
        <div key={u.l} className="rounded-lg border border-white/10 bg-black/40 backdrop-blur-md px-1 py-3 sm:py-4 text-center">
          <div className="font-display text-3xl sm:text-5xl font-black text-white tabular-nums leading-none">
            {String(u.v).padStart(2, "0")}
          </div>
          <div className="mt-1 font-mono text-[9px] sm:text-[11px] uppercase tracking-widest text-amber-500">{u.l}</div>
        </div>
      ))}
    </div>
  );
};
